/**
 * 资金账户
 */
import service from '@/request/api';
// 导入api接口
export default {
  namespaced: true,
  state: {
    form: {
      corpName: '', // 企业名称
      taxNo: '', // 企业税号
      userType: '', // 申请人类型
      borrowerName: '', // 姓名
      borrowerIdentity: '', // 身份证号
      borrowerPhone: '', // 手机号码
      captcha: '', // 短信验证
      loanAmount: '', // 借款金额
      termLoan: '', // 借款期限
      loanIntendedUse: '', // 借款用途
      referrer: '', // 邀请码
      LocatedPlacePicker: '', // 经营地址
      marriage: '', // 婚姻状况
      relationshipWith: '',
      marriageRelationshipWith: '',
      bizAddress: '',
      bizAddressCode: '',
      borrowerType: '',
      borrowerAddress: '',
      livingBorrowerAddress: '',
      borrowerAddressCode: '',
      bankCard: '', // 银行卡号
      iceContactName: '', // 紧急联系人姓名
      iceContactIdentity: '', // 紧急联系人身份证号
      iceContactPhone: '', // 紧急联系人电话
      creditBankCard: '', // 信用卡号
      borrowerEmail: '',
      borrowerLiveType: '',
      education: '',
      corpId: '',
      creditAccount: '',
      relationMobilePhone: '',
      relationName: '',
      operatingIncome: '', // 营业收入
      practitioners: '', // 从业人员
      totalAssets: '', // 资产总额
      financeStaffName: '', // 财务联系人姓名
      financeStaffPhone: '', // 财务联系人电话
      isAgree: true,
    },
    orderId: localStorage.getItem('orderId'), //  订单号
    phone: '',
    borrowerPhone: '',
    identity: '',
    userName: '',
    personAuthStatus: '',
    borrowerType: '',
    card_num: '', // 银行卡号
    bindingCardId: '',
    min: '',
    max: '',
    submitInfoAll: {},
    tabActive: 1,
    prohibitionDivorce: false,
    isShowCorpName: false,
    haierIndex: '',
    userId: '',
    isPicCodeShow: false,
    imgUrl: '',
  },
  mutations: {
    updateState(state, obj) {
      for (const key in obj) {
        state[key] = obj[key];
      }
    },
    updateFormState(state, obj) {
      for (const key in obj) {
        if (state.form[key] !== obj[key]) {
          state.form[key] = obj[key];
        }
      }
    },
  },
  actions: {
    getUserInfo(context) {
      service.PublicPage.getUserInfo().then((res) => {
        const {
          phone, userName, identity, personAuthStatus, userId,
        } = res.data;
        console.log(!!personAuthStatus);
        context.commit('updateState', {
          userId,
          phone,
          userName,
          identity,
          personAuthStatus: !!personAuthStatus,
        });
      });
    },
    sendPicCode(context,phone) {
      service.PublicPage.getVerify({
        phone:phone?phone:context.state.submitInfoAll.borrowerPhone,
        type:'1',
      })
        .then((res) => {
          let str = '';
          if (res.success) {
            if (res.data.type === 'png') {
              str = `data:image/png;base64,${res.data.file}`;
            } else {
              str = `data:image/jpg;base64,${res.data.file}`;
            }
          }
          context.commit('updateState', {
            imgUrl:str,
            isPicCodeShow:true,
          });
        })
        .catch(() => { });
    },
  },
  getters: {
    // nextStep: (state) => {
    //   return state.nextStep
    // },
  },
};
